const messages = {
    en: {
      results: "Results",
      belowAreResults: "Below are your tests results",
      subjects: "Subjects",
      subject: "Subject",
      filterResults: "Filter results",
      itemsPerPage: "Items qty per page",
      sortingOptons: "Sort",
      score: "Score",
      answeredQuestions: "Answered",
      createdAt: "Date",
      testDateAsc: "Testing date asc",
      testDateDesc: "Testing date dec",
      resultsAsc: "Testing results asc",
      resultsDesc: "Testing results desc",
      subjAsc: "Subjects asc",
      subjsDesc: "Subjects desc",
      noResults: "No results"


    },
    ru: {
      results: "Pезультаты",
      belowAreResults: "Pезультаты ваших тестов",
      subjects: "Предметы",
      subject: "Предмет",
      filterResults: "Фильтровать результаты",
      itemsPerPage: "Pез. на страницу",
      sortingOptons: "Сорт",
      score: "Бaлл",
      answeredQuestions: "Bопросов",
      createdAt: "Дата",
      testDateAsc: "Дата тестиров. возр.",
      testDateDesc: "Дата тестиров. убыв.",
      resultsAsc: "Результаты возр.",
      resultsDesc: "Результаты убыв.",
      subjAsc: "Предметы возр.",
      subjsDesc: "Предметы убыв.",
      noResults: "Нет результатов"
    }
  };

  export default messages;